module.exports = __webpack_public_path__ + "img/icon_inspect_completed.058299cc.png";